export default __webpack_public_path__ + "static/hram-ikony-bozhiej-materi-sporitelnica-hlebov-krovlya_6-b60f746837309a88a1c1b5842aca3772.jpg";